import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  DEFAULT_IMAGE,
  SITE_NAME,
  getCanonicalUrl,
  getMetadataForPath,
  getSchemasForPath,
} from "../seo";

const setMetaTag = (selector, attributes) => {
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    document.head.appendChild(tag);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    tag.setAttribute(key, value);
  });
};

const setLinkTag = (rel, href) => {
  let tag = document.head.querySelector(`link[rel="${rel}"]`);

  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    document.head.appendChild(tag);
  }

  tag.setAttribute("href", href);
};

const Seo = () => {
  const location = useLocation();

  useEffect(() => {
    const metadata = getMetadataForPath(location.pathname);
    const canonicalUrl = getCanonicalUrl(location.pathname);

    document.title = metadata.title;

    setMetaTag('meta[name="description"]', {
      name: "description",
      content: metadata.description,
    });
    setMetaTag('meta[property="og:site_name"]', {
      property: "og:site_name",
      content: SITE_NAME,
    });
    setMetaTag('meta[property="og:type"]', {
      property: "og:type",
      content: metadata.type,
    });
    setMetaTag('meta[property="og:title"]', {
      property: "og:title",
      content: metadata.title,
    });
    setMetaTag('meta[property="og:description"]', {
      property: "og:description",
      content: metadata.description,
    });
    setMetaTag('meta[property="og:url"]', {
      property: "og:url",
      content: canonicalUrl,
    });
    setMetaTag('meta[property="og:image"]', {
      property: "og:image",
      content: DEFAULT_IMAGE,
    });
    setMetaTag('meta[property="og:image:width"]', {
      property: "og:image:width",
      content: "1000",
    });
    setMetaTag('meta[property="og:image:height"]', {
      property: "og:image:height",
      content: "560",
    });
    setMetaTag('meta[name="twitter:card"]', {
      name: "twitter:card",
      content: "summary_large_image",
    });
    setMetaTag('meta[name="twitter:title"]', {
      name: "twitter:title",
      content: metadata.title,
    });
    setMetaTag('meta[name="twitter:description"]', {
      name: "twitter:description",
      content: metadata.description,
    });
    setMetaTag('meta[name="twitter:image"]', {
      name: "twitter:image",
      content: DEFAULT_IMAGE,
    });

    if (metadata.noindex) {
      setMetaTag('meta[name="robots"]', {
        name: "robots",
        content: "noindex, follow",
      });
    } else {
      const robots = document.head.querySelector('meta[name="robots"]');
      if (robots) {
        robots.remove();
      }
    }

    setLinkTag("canonical", canonicalUrl);

    document
      .querySelectorAll('script[data-kynetic-schema="true"]')
      .forEach((script) => script.remove());

    getSchemasForPath(location.pathname).forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.kyneticSchema = "true";
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  }, [location.pathname]);

  return null;
};

export default Seo;
